import { differenceInMonths } from 'date-fns';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;

const MONTHS_IN_YEAR = 12;
const MONTHS_IN_DECADE = MONTHS_IN_YEAR * 10;
const MONTHS_IN_CENTURY = MONTHS_IN_DECADE * 10;
const MONTHS_IN_MILLENNIUM = MONTHS_IN_CENTURY * 10;

const LONG_UNITS = [
  { months: MONTHS_IN_MILLENNIUM, singular: 'millennium', plural: 'millennia' },
  { months: MONTHS_IN_CENTURY, singular: 'century', plural: 'centuries' },
  { months: MONTHS_IN_DECADE, singular: 'decade', plural: 'decades' },
  { months: MONTHS_IN_YEAR, singular: 'year', plural: 'years' },
  { months: 1, singular: 'month', plural: 'months' }
];

function toUnitLabel(count, singular, plural) {

  if (count === 1) {
    return '1 ' + singular + ' ago';
  }

  return count + ' ' + plural + ' ago';

}

function toLongFuzzyTime(currentTime, date) {

  const months = differenceInMonths(currentTime, date);

  if (months < 1) {
    return toUnitLabel(Math.floor((+currentTime - date) / WEEK), 'week', 'weeks');
  }

  for (let index = 0; index < LONG_UNITS.length; index++) {

    const unit = LONG_UNITS[index];

    if (months >= unit.months) {
      return toUnitLabel(Math.floor(months / unit.months), unit.singular, unit.plural);
    }

  }

}

export function toFuzzyTime(currentTime, date) {

  const delta = +currentTime - date;

  if (delta < 30 * SECOND) {
    return 'just now';
  }

  if (delta < MINUTE) {
    return Math.floor(delta / SECOND) + ' secs ago';
  }

  if (delta < 2 * MINUTE) {
    return 'a min ago';
  }

  if (delta < HOUR) {
    return Math.floor(delta / MINUTE) + ' mins ago';
  }

  if (delta < 2 * HOUR) {
    return '1 hr ago';
  }

  if (delta < DAY) {
    return Math.floor(delta / HOUR) + ' hrs ago';
  }

  if (delta < 2 * DAY) {
    return 'yesterday';
  }

  if (delta < WEEK) {
    return Math.floor(delta / DAY) + ' days ago';
  }

  return toLongFuzzyTime(currentTime, date);

}
